<template>
  <a-dropdown
    :trigger="[trigger]"
    :placement="placement"
    :disabled="!menus?.length"
    overlay-class-name="base-drop-down"
    transition-name=""
    @visible-change="onVisibleChange"
  >
    <div class="h-full relative" :class="{ 'cursor-not-allowed': disabled }">
      <slot />
    </div>

    <template v-if="menus?.length && disabled !== true" #overlay>
      <a-menu
        force-sub-menu-render
        class="bg-black overflow-auto _menu"
        theme="dark"
        transition-name=""
      >
        <template v-for="menu in menus" :key="menu.title">
          <template v-if="!menu.hidden">
            <MenuItem :menu-item="menu" :width="width" />
          </template>
        </template>
      </a-menu>
    </template>
  </a-dropdown>
</template>

<script lang="ts" setup>
import { PropType } from 'vue';
import MenuItem from './MenuItem.vue';
import { emitter, EventType } from '@/utils/emitter.utils';

defineProps({
  trigger: {
    type: String as PropType<'contextmenu' | 'hover' | 'click'>,
    default: 'hover'
  },
  menus: {
    type: Array as PropType<DropDownMenuItem[]>,
    default: () => []
  },
  disabled: {
    type: Boolean,
    default: false
  },
  width: {
    type: Number,
    default: 180
  },
  placement: {
    type: String as PropType<
      'bottomLeft' | 'bottom' | 'bottomRight' | 'topLeft' | 'top' | 'topRight'
    >,
    default: 'bottomLeft'
  }
});
const emits = defineEmits<{
  (event: 'show'): void;
}>();
const onVisibleChange = (visible: boolean) => {
  emitter.emit(EventType['dropdown:visibleChange'], visible);
  emits('show');
};
</script>

<style lang="less" scoped>
._menu {
  max-height: calc(100vh - 10px);
}
</style>
